import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import Tooltip from '@atlaskit/tooltip';
import { FormattedMessage } from 'react-intl-next';
import { TOOLTIP_USERS_LIMIT } from '../../shared/constants';
import { messages } from '../../shared/i18n';
import { emojiNameStyle, footerStyle, tooltipStyle, underlineStyle } from './styles';

/**
 * Test id for wrapper ReactionTooltip div
 */
export var RENDER_REACTIONTOOLTIP_TESTID = 'render-reactionTooltip';
export var ReactionTooltip = function ReactionTooltip(_ref) {
  var children = _ref.children,
    emojiName = _ref.emojiName,
    _ref$reaction = _ref.reaction,
    _ref$reaction$users = _ref$reaction.users,
    users = _ref$reaction$users === void 0 ? [] : _ref$reaction$users,
    _ref$reaction$emojiId = _ref$reaction.emojiId,
    emojiId = _ref$reaction$emojiId === void 0 ? '' : _ref$reaction$emojiId,
    _ref$maxReactions = _ref.maxReactions,
    maxReactions = _ref$maxReactions === void 0 ? TOOLTIP_USERS_LIMIT : _ref$maxReactions,
    handleUserListClick = _ref.handleUserListClick,
    _ref$allowUserDialog = _ref.allowUserDialog,
    allowUserDialog = _ref$allowUserDialog === void 0 ? false : _ref$allowUserDialog,
    _ref$isEnabled = _ref.isEnabled,
    isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled;
  /**
   * Render list of users in the tooltip box
   */
  var content = !users || users.length === 0 || !isEnabled ? null :
  // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  jsx("div", {
    css: tooltipStyle,
    tabIndex: 0
  }, jsx("ul", null, emojiName ? jsx("li", {
    css: emojiNameStyle
  }, emojiName) : null, users.slice(0, maxReactions).map(function (user) {
    return jsx("li", {
      key: user.id
    }, user.displayName);
  }), jsx("li", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    css: allowUserDialog ? [footerStyle, underlineStyle] : footerStyle,
    onClick: function onClick() {
      if (allowUserDialog && handleUserListClick) {
        handleUserListClick(emojiId);
      }
    }
  }, users.length > maxReactions ? jsx(FormattedMessage, _extends({}, messages.otherUsers, {
    values: {
      count: users.length - maxReactions
    }
  })) : allowUserDialog && jsx(FormattedMessage, messages.moreInfo))));
  return jsx(Tooltip, {
    content: content,
    position: "bottom",
    testId: RENDER_REACTIONTOOLTIP_TESTID
  }, React.Children.only(children));
};